import { styled } from "styled-components";

export const MoonSVG = styled.svg``;

export const MoonPath = styled.path``;
